// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/flight-controls.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/flight-controls/flight-controls.js';

mount([g0]);
